// VHW-147 — the course-search AJAX endpoints are registered as site-base-relative
// paths. On a subpath install (e.g. stage under /main/) a root-absolute fetch
// misses the endpoint, so resolve every endpoint against the site base the page
// head exposes via <meta name="course-api-base">. Falls back to the document
// root when the meta tag is absent.
const readBase = (): string => {
  const raw = document.querySelector<HTMLMetaElement>('meta[name="course-api-base"]')?.content || '/'
  return raw.endsWith('/') ? raw : `${raw}/`
}

export const apiUrl = (path: string): string => {
  const base = new URL(readBase(), window.location.origin)
  // Force scheme to match the current page so that CSP 'self' always matches,
  // even when {site.base} in TYPO3 is configured with a different protocol (e.g. http vs https).
  base.protocol = window.location.protocol
  return new URL(path.replace(/^\/+/, ''), base).toString()
}
